import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { Control, Controller, FieldPath } from 'react-hook-form';
import { GroupTemplateFormData } from './group-template-form-data';
import { FormOption } from './group-template-form-options';

interface TemplateSelectFieldProps {
  name: FieldPath<GroupTemplateFormData>;
  control: Control<GroupTemplateFormData>;
  label?: string;
  /** Id of a visible heading that labels the field in place of `label`. */
  labelledBy?: string;
  helperText?: string;
  options: FormOption[];
  disabled?: boolean;
  onChange?: (value: string) => void;
}

export function TemplateSelectField({
  name,
  control,
  label,
  labelledBy,
  helperText,
  options,
  disabled,
  onChange,
}: TemplateSelectFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          select
          fullWidth
          disabled={disabled}
          label={label}
          helperText={fieldState.error?.message || helperText || ' '}
          error={!!fieldState.error}
          inputProps={{ id: name }}
          InputLabelProps={{ htmlFor: name }}
          SelectProps={labelledBy ? { labelId: labelledBy } : undefined}
          value={field.value || ''}
          onChange={(event) => {
            field.onChange(event.target.value);
            onChange?.(event.target.value);
          }}
        >
          {options.map((option) => (
            <MenuItem value={option.value} key={option.displayValue}>
              {option.displayValue}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}
